<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentScoringEntry.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentScoringEntry.tableEntry'),
            href: '/student-scoring-entries'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <ts-card>
        <ts-card-wrapper>
          <div class="row">
            <div class="col-md-12">
              <HeadderComponent
                v-model="model"
                @fetchStudent="fetchStudent"
                @scoreEntities="setScoreEntities"
                @on-cycle-value-change="onOnCycleValueChange"
                @clearEntities="() => (scoreEntities = [])"
                :selectedSubjectId="selectedSubjectId"
              />
            </div>
          </div>
          <br />
        </ts-card-wrapper>
      </ts-card>
      <ts-card class="ts-mt-4">
        <ts-card-wrapper>
          <div class="ts-overflow-auto">
            <NumberingScoreTable
              v-model="model"
              v-if="model.score_type == 1"
              :students="students"
              :scoreEntities="scoreEntities"
              :attendances="attendances"
              :selectedSubjectId="selectedSubjectId"
              ref="numering"
            />
            <div
              v-if="model.score_type == null"
              class="ts-h-64 ts-flex ts-items-center ts-justify-center"
            >
              <div class="ts-text-center ts-opacity-50">
                <i class="far fa-list-alt fa-4x"></i>
                <h1 class="ts-font-bold ts-text-gray-600">No Record</h1>
              </div>
            </div>
          </div>
          <div class="ts-space-x-3 ts-flex ts-justify-end ts-mt-3">
            <ts-button color="primary" @click.prevent="onStore">{{
              $t('save')
            }}</ts-button>
          </div>
        </ts-card-wrapper>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>

<script>
import { formViewModel, store } from '@/api/student-scoring-table-entry'
import { Errors } from 'form-backend-validation'
import { mapMutations, mapState } from 'vuex'
import HeadderComponent from './table-entry-component/header-component.vue'
import NumberingScoreTable from './table-entry-component/numberingScoreTable.vue'

export default {
  name: 'scoringEntryAsTable',
  components: {
    HeadderComponent,
    NumberingScoreTable
  },
  data() {
    return {
      errors: new Errors(),
      students: [],
      scoreEntities: [],
      attendances: {},
      selectedSubjectId: {
        id: []
      },
      model: {
        class_id: null,
        grade_id: null,
        scoring_cycle_id: null, // 1: monthly , 2 semester
        score_type: null,
        acps_id: null,
        cycle_value: null,
        acp_id: null,
        ac_year_id: null,
        ac_term_id: null,
        program_structure_id: null,
        ac_category_id: 0,
        score_sc_bas_id: 1, // item base default,
        subject_order: undefined,
        sc_item_subject_comp_list: []
      }
    }
  },
  created() {},
  computed : {
    ...mapState('studentScoringEntryTable', ['loading'])
  },
  methods: {
    ...mapMutations('studentScoringEntryTable', ['isLoading']),
    fetchStudent() {
      this.isLoading(true)
      return formViewModel({
        params: {
          fnName: 'students',
          class_id: this.model.class_id,
          subject_order: this.model.subject_order
        }
      })
        .then(({ data }) => {
          this.students = data.students
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.isLoading(false)
        })
    },
    setScoreEntities(scoreEntities) {
      this.scoreEntities = scoreEntities.entities
      this.attendances = scoreEntities.attendances
    },
    onOnCycleValueChange() {
      this.$refs.numering.onCycleValue()
    },
    onStore() {
      this.isLoading(true)
      store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$refs.numering.onCycleValue()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.isLoading(false)))
    }
  }
}
</script>
